import env from "$lib/env";
import { get } from "svelte/store";
import settings from "$lib/state/settings";

// 👑 Matriz Suprema envuelta en CorsProxy Universal
const PROXY = "https://corsproxy.io/?";

export const PUBLIC_INSTANCES = [
    `${PROXY}https://api.cobalt.lol`,
    `${PROXY}https://cobalt-api.pepegcj.dev`,
    `${PROXY}https://cobalt.kwiate.ch`,
    `${PROXY}https://co.wuk.sh`
];

let workingIndex = 0;

export const currentApiURL = () => {
    const processingSettings = get(settings).processing;
    const customInstanceURL = processingSettings.customInstanceURL;

    if (processingSettings.enableCustomInstances && customInstanceURL && customInstanceURL.trim().length > 0) {
        try { return new URL(customInstanceURL).origin; } catch(e) {}
    }

    return PUBLIC_INSTANCES[workingIndex];
}

export const nextApiURL = () => {
    workingIndex = (workingIndex + 1) % PUBLIC_INSTANCES.length;
    return PUBLIC_INSTANCES[workingIndex];
}